import { API_SERVICE } from "./root";
//  导入pb文件
//  系统配置参数proto
import { CollectionServiceClient } from "@/pbjs/external/ticket/collection_grpc_web_pb";
//  命名请求对象
const collectionServiceClient: any = new CollectionServiceClient(
  API_SERVICE,
  null,
  null
);

export { collectionServiceClient };
